import React from "react";
import { v4 as uuidv4 } from "uuid";

interface Chunk {
  words: string;
  backgroundColor?: string;
}

/** キーワードハイライト設定IF */
export interface KeywordHighlightConfig {
  keyword: string;
  backgroundColor: string;
}

/**
 * span要素を取得する
 */
const getSpan = (chunk: Chunk): React.ReactNode => {
  if (chunk.backgroundColor !== undefined) {
    // backgroundColorが設定されている場合は単語で区切られているはずなので改行処理しない
    return (
      <span key={uuidv4()} style={{ backgroundColor: chunk.backgroundColor }}>
        {chunk.words}
      </span>
    );
  }
  let texts = chunk.words.split('\n')
  return <span key={uuidv4()}>{texts.map((str, i) => (<>{str} {i !== texts.length - 1 ? <br /> : ""}</>))}</span>;
};

/**
 * 文章をキーワードの前後を区切りに文字列チャンク化する
 *
 */
const splitToChunkString = (
  sentences: string[],
  keyword: string,
  keywords: string[]
): string[] => {
  const result: string[] = [];
  sentences.forEach((sentence: string) => {
    if (keywords.includes(sentence)) {
      result.push(sentence);
    } else {
      const excludeKeyword = sentence.split(keyword);
      excludeKeyword.forEach((exSentence: string) => {
        result.push(exSentence);
        result.push(keyword);
      });
      // 最後の要素は不要なので除外
      result.pop();
    }
  });
  return result;
};

/**
 * 文章をキーワードの前後を区切りにチャンクオブジェクト化する
 *
 */
const getChunks = (
  content: string,
  configs: KeywordHighlightConfig[]
): Chunk[] => {
  // 検索ワードのセットを作成
  let keywords: string[] = Array.from(new Set(configs.map(kw => kw.keyword)));

  // 検索ワードの文字長降順にソート
  keywords = keywords.sort((a: string, b: string) => {
    if (a.length > b.length) return -1;
    return 1;
  });

  // キーワードのチャンク(文字列)で分割する
  let strChunks: string[] = [content];
  keywords.forEach((keyword: string) => {
    strChunks = splitToChunkString(strChunks, keyword, keywords);
  });

  // チャンクをオブジェクト化する
  const objChunks: Chunk[] = [];
  strChunks.forEach((chunk: string) => {
    if (keywords.includes(chunk)) {
      const bgColor = configs.find(
        (config: KeywordHighlightConfig) => config.keyword === chunk
      )?.backgroundColor;
      objChunks.push({ words: chunk, backgroundColor: bgColor });
    } else {
      objChunks.push({
        words: chunk,
      });
    }
  });

  return objChunks;
};

interface Props {
  content: string;
  configs?: KeywordHighlightConfig[];
  highlight?: boolean;
}

/** キーワードハイライター */
export function KeywordHighlighter(props: Props) {
  const { content, configs, highlight = true } = props;

  if (!configs || !highlight) {
    return <>{content.split('\n').map(str => (<>{str}<br /></>))}</>;
  }
  return (
    <>{getChunks(content, configs).map((chunk: Chunk) => getSpan(chunk))}</>
  );
}
